import $ from 'jquery';

function analytics_event(ev) {
  let path_array = document.location.pathname.split('/');
  const docname = path_array.pop();
  const product = path_array.pop();

  let obj = {
    'event': 'lrd-feedback-form',
    'lrd-feedback-form': {
      'name':       docname,
      'product':    product,
      'event':          ev,
      'question-1':     false,
      'question-2':     false,
      'question-3':     '',
      'question-4':     '',
    }
  };

  let formData = $('.js-feedback__form').serializeArray(); 
  formData.forEach( (question) => {
    const key = '' + question.name;
    const prior = obj['lrd-feedback-form'][key];
    if (!prior) {
      obj['lrd-feedback-form'][key] = question.value;
    } else {
      obj['lrd-feedback-form'][key] = prior + '|' + question.value;
    }
  });

  obj['lrd-feedback-form']['question-3'] = obj['lrd-feedback-form']['question-3'].split('|');
  obj['lrd-feedback-form']['question-4'] = obj['lrd-feedback-form']['question-4'].split('|');

  window.dataLayer.push(obj);
}

export default function feedback() {
  let feedbackQuestion = 0;

  // open/closed feedback
  $('.js-feedback-toggle-btn').on('click', function () {
    analytics_event('modal-toggled');
    $(this).closest('.js-feedback').toggleClass('is-active');
  });

  $('.js-feedback-control').on('change', function () {
    // menu option clicked
    analytics_event('form-step-done');
    if ( $(this).is(':checked') ) {
      const nextBlocks = $(this).data('next-block').split(',');

      $(this).closest('[data-block]').hide();

      nextBlocks.forEach(nextBlock => {
        $(`[data-block=${nextBlock}]`).show();
      });
    }

    feedbackQuestion++;
    $('.js-feedback-question-number').text(feedbackQuestion);
  });

  // Submitted feedback
  $('.js-feedback-submit-btn').on('click', function () {
    $('[data-block]').hide();
    $('[data-block="thank-you"]').show();
    analytics_event('form-completed');
  });

  $('.js-collapse-feedback-toggle-btn').on('click', function (e) {
    e.stopPropagation();

    $('.js-feedback-toggle-btn').addClass('is-collapsed');
  });
}



// WEBPACK FOOTER //
// ./src/assets/js/project/feedback.js